function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.314-1.005a70 70 0 0070 70v-70h-70z"
});

function SvgCircleQuarter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 69,
    viewBox: "0 0 71 69",
    fill: "currentColor"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzEiIGhlaWdodD0iNjkiIHZpZXdCb3g9IjAgMCA3MSA2OSIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC4zMTM5NzUgLTEuMDA1MDZDMC4zMTM5NzYgOC4xODc0NyAyLjEyNDU4IDE3LjI5IDUuNjQyNDEgMjUuNzgyOEM5LjE2MDI0IDM0LjI3NTYgMTQuMzE2NCA0MS45OTIzIDIwLjgxNjUgNDguNDkyNEMyNy4zMTY2IDU0Ljk5MjUgMzUuMDMzMyA2MC4xNDg3IDQzLjUyNjEgNjMuNjY2NUM1Mi4wMTg5IDY3LjE4NDMgNjEuMTIxNCA2OC45OTQ5IDcwLjMxNCA2OC45OTQ5TDcwLjMxNCAtMS4wMDUwNkwwLjMxMzk3NSAtMS4wMDUwNloiIC8+Cjwvc3ZnPgo=";
export { SvgCircleQuarter as ReactComponent };